import { Card, SkeletonBodyText } from "@medentic/polaris-react";
import { Patient } from "../../types";

interface ImagesTabContentProps {
  patient?: Patient;
  loading?: boolean;
}

function ImagesTabContent({ patient, loading }: ImagesTabContentProps) {
  if (loading) {
    return (
      <Card>
        <SkeletonBodyText lines={10} />
      </Card>
    );
  }

  return <Card>{patient?.core_images}</Card>;
}

export default ImagesTabContent;
